module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('el-row', {
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.form,
      "label-width": "120px",
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('auth.firstname'),
      "prop": "firstname",
      "rules": [{
        required: true,
        message: 'Please input firstname',
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.firstname),
      callback: function($$v) {
        _vm.form.firstname = $$v
      },
      expression: "form.firstname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('auth.lastname'),
      "prop": "lastname",
      "rules": [{
        required: true,
        message: 'Please input lastname',
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.lastname),
      callback: function($$v) {
        _vm.form.lastname = $$v
      },
      expression: "form.lastname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('auth.username'),
      "prop": "username",
      "rules": [{
        required: true,
        message: 'Please input username',
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.username),
      callback: function($$v) {
        _vm.form.username = $$v
      },
      expression: "form.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('auth.email'),
      "prop": "email",
      "rules": [{
        type: 'email',
        message: 'Please input correct email address',
        trigger: 'blur,change',
        required: true
      }]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.form.email = $$v
      },
      expression: "form.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('auth.password'),
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.form.password = $$v
      },
      expression: "form.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('auth.passwordConfirmation'),
      "prop": "passwordConfirmation"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.passwordConfirmation),
      callback: function($$v) {
        _vm.form.passwordConfirmation = $$v
      },
      expression: "form.passwordConfirmation"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('auth.roles'),
      "prop": "roleId",
      "rules": [{
        required: true
      }]
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('auth.rolesPlaceholder')
    },
    model: {
      value: (_vm.form.roleId),
      callback: function($$v) {
        _vm.form.roleId = $$v
      },
      expression: "form.roleId"
    }
  }, _vm._l((_vm.roles), function(r) {
    return _c('el-option', {
      key: r.id,
      attrs: {
        "label": r.name,
        "value": r.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.onSubmit(_vm.form)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('base.save')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": function($event) {
        _vm.navigate({
          name: 'user.view'
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('base.cancel')))])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-989208e2"}!./src/pages/user/edit/index.html
// module id = 818
// module chunks = 1